import React from 'react';
import { Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import logo from 'resources/logo.png';
import * as styles from './styles';
import { withRouter } from 'react-router-dom';
import Auth from 'stores/Auth';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import { observable } from 'mobx/lib/mobx';
import API from 'api';
import qs from 'qs';

// example url http://localhost:5000/#/authCode?code=wp8dGKUT8tufeA56bNdBUEZexnLq2W

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class AuthCode extends React.Component {
	propTypes: {
		auth?: Auth
	};

	msgStore = new MsgStore();

	@observable isLoading: boolean = true;

	requestTokenAndRedirect = async () => {
		this.isLoading = true;
		const { auth } = this.props;
		const params = qs.parse(location.hash.substr(location.hash.indexOf('?') + 1));
		const { code } = params;
		if (code) {
			try {
				await auth.authenticateUserProda(code);
				const role = this.props.auth.user?.role;
				if (role === 'admin') this.props.auth.logOut();
				const path = role === 'manager' ? 'manager' : 'user';
				this.isLoading = false;
				this.props.history.push(`/app/${path}`);
			} catch (e) {
				const path = path || '';
				this.props.history.push(`/app/${path}?error=` + e.message);
			}
		}
	};

	componentDidMount() {
		this.requestTokenAndRedirect();
	}

	render() {
		const { isLoading } = this;
		return (
			<Segment loading={true}>
				<div>Requesting token...</div>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/public/AuthCode/index.js